import message from 'antd/lib/message';

const ErrorHelpers = {};

// handelGraphqlError
// takes in a graphql error, maps over it to get the strings,
// and then does an antd message for each error string it fings
ErrorHelpers.handelGraphqlError = e => {
  let errorStrings = e.graphQLErrors.map(x => x.message.replace('GraphQL', ''));

  if (errorStrings && errorStrings.length > 0) {
    errorStrings.forEach(error => {
      message.error(error);
    });
  } else {
    message.error('Something went wrong!');
  }
};

ErrorHelpers.handleError = err => {
  // check if the error has a simple err.message we can just display, if it does, fire an antd message
  if (err && err.message) {
    return message.error(err.message);
  }

  // check if the error is from grapqhl, if it is, handle it.
  if (err && err.graphQLErrors) {
    return ErrorHelpers.handelGraphqlError(err);
  }

  return message.error('hmm... somethign went wrong.');
};

export default ErrorHelpers;



// WEBPACK FOOTER //
// ./src/lib/helpers/ErrorHelpers/index.js